export const getStatusColor = status => {
    switch (status.toLowerCase()) {
        case 'active':
            return 'bg-green-100 text-green-800';
        case 'inactive':
            return 'bg-gray-100 text-gray-800';
        default:
            return 'bg-blue-100 text-blue-800';
    }
};
 
export const getInventoryLeftColor = days => {
    if (days === 'N/A') return 'bg-gray-100 text-gray-800';
    const daysNum = parseFloat(days);
    if (isNaN(daysNum)) return 'bg-gray-100 text-gray-800';
    if (daysNum <= 180) return 'bg-red-100 text-red-800';
    if (daysNum >= 181 && daysNum <= 220) return 'bg-yellow-100 text-yellow-800';
    return 'bg-green-100 text-green-800';
};


const InfoItem = ({ label, value, isStatus, isInventory, testId }) => {
    let badgeClass = '';
    if (isStatus) {
        badgeClass = getStatusColor(value);
    } else if (isInventory) {
        badgeClass = getInventoryLeftColor(value);
    }

    return (
        <div className="flex justify-between items-center" data-testid={testId}>
            <span className="font-medium">{label}:</span>
            {(isStatus || isInventory) ? (
                <span 
                    data-testid={testId ? `badge-status-${testId}` : undefined} 
                    className={`px-2 py-1 rounded-full text-sm ${badgeClass}`}
                >
                    {value}
                </span>
            ) : (
                <span data-testid={testId ? `default-status-${testId}` : undefined}>
                    {value}
                </span>
            )}
        </div>
    );
};

export default InfoItem; 